import { useContext } from 'react'
import { ClientEnvironmentContext } from './globalConfig'

export function GetUmbracoBaseUrl() {
  const clientEnvironment = useContext(ClientEnvironmentContext)
  return clientEnvironment!.umbracoBaseUrl
}

export function BuildUmbracoUrl(path: string) {
  return `${GetUmbracoBaseUrl()}${path?.replace(/^\//, '')}`
}
